import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            fr: {
                translation: {
                    home: 'Accueil',
                    about: 'À propos',
                    ourServices: 'Nos services',
                    carottagePro:"Carottage Pro",
                    serviceProfessionnel: "Service Professionnel",
                    interventionRapide: "Intervention Rapide",
                    services: "Services",
                    carottage: "Carottage",
                    carottageDescription: "Crottage Pro vous offre une gamme complète de services de carottage, sciage et démolition pour répondre à tous vos besoins en construction et rénovation. Que vous ayez besoin de créer des ouvertures précises dans le béton, de découper des matériaux ou de démolir des structures, notre équipe d'experts est là pour vous fournir des solutions efficaces et professionnelles.",
                    carottageDescription2: "Le carottage diamant permet de réaliser des ouvertures circulaires d’une grande précision dans des structures en béton armé. Il garantit un perçage net et sans éclats, avec une parfaite maîtrise des axes, du diamètre et de l’inclinaison, idéal pour le passage et l’installation de gaines VMC, climatisation, évacuations ou chemins de câbles.",
                    sciage: "Sciage",
                    sciageDescription: "Le sciage est une technique précise permettant de réaliser des ouvertures sur différents types de parois et de structures en béton. Cette méthode garantit des découpes nettes et soignées, sans vibrations, afin de préserver l’intégrité et la solidité des structures.",
                    demolition: "Démolition",
                    demolitionDescription: "La démolition du béton armé repose sur des techniques précises permettant d’intervenir efficacement sur tous types de structures. Qu’il s’agisse d’une démolition partielle ou complète, les travaux sont réalisés avec soin afin de préserver les éléments voisins et garantir des interventions propres et sécurisées.",
                    joinUs: "Nous joindre",
                    getInTouch: "Nous contacter",
                    getInTouchDescription: "Confiez-nous vos travaux de carottage, de sciage et de démolition en Tunisie et bénéficiez d’un résultat de qualité, conforme à vos attentes. Pour plus d’informations, n’hésitez pas à nous contacter.",
                    expertCarottage: "Experts en carottage en Tunisie",
                    expertCarottageDescription: "Experts en carottage professionnel pour tous types de murs. Nous réalisons vos ouvertures et passages techniques avec une précision optimale grâce à des équipements professionnels de haute performance, garantissant un travail rapide, propre et soigné.",
                    enterEmail: "Saisissez votre email",
                    yourMessage: "Votre message ici...",
                    submit: "Soumettre",
                    subject: "Sujet",
                    whoWeAre: "Qui sommes-nous",
                    whoWeAreDescription: "est une entreprise spécialisée dans les travaux de",
                    whoWeAreDescription2: "notamment le carottage, le sciage et la démolition en Tunisie.",
                    whoWeAreDescription3: " Nous mettons à votre disposition notre expertise ainsi que des équipements professionnels performants afin de réaliser des interventions précises, propres et adaptées à tous types de chantiers. Grâce à des techniques de pointe, nous intervenons sur différents matériaux, qu’il s’agisse de béton, de murs en maçonnerie ou d’autres structures, tout en garantissant un travail soigné et de haute qualité.",
                    whoWeAreDescription4: "Nous réalisons également des travaux de démolition partielle ou totale, en assurant des opérations sécurisées et maîtrisées afin de préserver les structures environnantes et limiter tout impact sur le site.",
                    whoWeAreDescription5: "Forts de notre expérience et de notre engagement envers la qualité, nous accompagnons aussi bien les particuliers que les professionnels dans la réalisation de leurs projets, depuis l’étude des besoins jusqu’à lexécution finale des travaux.",
                    comingSoon: "Bientôt disponible",
                    contactUs: "Contactez-nous",
                    messageGetInTouch: 'Merci de nous avoir contactés. Nous avons bien reçu votre message et notre équipe en prendra connaissance sous peu. Votre satisfaction est notre priorité, et nous vous répondrons dans les meilleurs délais.',
                    email: 'Email',
                    contact: 'Contact',
                    joinMessageFailedTitle: 'Oups! Une erreur est survenue',
                    messageDescription: "Échec de l'envoi du message. Veuillez réessayer plus tard.",
                    messageTitle: 'Merci pour votre message!',
                    dismiss: 'Fermer'

                }
            },
            ar: {
                translation: {
                    home: 'الرئيسية',
                    about: 'من نحن',
                    ourServices: 'خدماتنا',
                    carottagePro: 'شركة Carottage Pro',
                    serviceProfessionnel: 'خدمة احترافية',
                    interventionRapide: 'تدخل سريع',
                    services: 'خدماتنا',

                    carottage: 'الثقب الخرساني',
                    carottageDescription:
                        'تقدم لكم شركة Carottage Pro مجموعة متكاملة من خدمات الثقب الخرساني والقص والهدم لتلبية جميع احتياجاتكم في البناء والتجديد. سواء كنتم بحاجة إلى إنشاء فتحات دقيقة في الخرسانة أو قص المواد أو هدم المنشآت، فإن فريقنا المتخصص يوفر لكم حلولاً احترافية وفعالة.',

                    carottageDescription2:
                        'يتيح الثقب بالألماس إنجاز فتحات دائرية عالية الدقة في الهياكل الخرسانية المسلحة. ويضمن ثقوباً نظيفة دون تشققات أو تكسير مع تحكم كامل في المحاور والقطر وزاوية الحفر، مما يجعله مثالياً لتمرير وتركيب قنوات التهوية والتكييف وأنظمة الصرف ومسارات الكابلات.',

                    sciage: 'القص',
                    sciageDescription:
                        'القص تقنية دقيقة تسمح بإنجاز فتحات في مختلف أنواع الجدران والهياكل الخرسانية. تضمن هذه الطريقة قطوعاً نظيفة ومتقنة دون اهتزازات، مما يحافظ على سلامة وقوة المنشآت.',

                    demolition: 'الهدم',
                    demolitionDescription:
                        'يعتمد هدم الخرسانة المسلحة على تقنيات دقيقة تتيح التدخل بكفاءة في جميع أنواع الهياكل. سواء كان الهدم جزئياً أو كلياً، يتم تنفيذ الأعمال بعناية للحفاظ على العناصر المجاورة وضمان تدخلات آمنة ونظيفة.',

                    joinUs: 'تواصل معنا',
                    getInTouch: 'اتصل بنا',
                    getInTouchDescription:
                        'نضع خبرتنا في مجال الثقب والقص والهدم على ذمتكم في جميع أنحاء تونس، مع ضمان جودة التنفيذ والدقة في العمل وفق أعلى المعايير. لمزيد من المعلومات أو للحصول على استشارة، يسعدنا تواصلكم معنا.',

                    expertCarottage: 'خبراء الثقب الخرساني في تونس',
                    expertCarottageDescription:
                        'خبراء في الثقب الخرساني الاحترافي لجميع أنواع الجدران. نقوم بإنجاز الفتحات والممرات التقنية بدقة عالية باستخدام معدات احترافية متطورة، مما يضمن عملاً سريعاً ونظيفاً ومتقناً.',

                    enterEmail: 'أدخل بريدك الإلكتروني',
                    yourMessage: 'اكتب رسالتك هنا...',
                    submit: 'إرسال',
                    subject: 'الموضوع',

                    whoWeAre: 'من نحن',
                    whoWeAreDescription:
                        'هي شركة متخصصة في أعمال',
                    whoWeAreDescription2:
                        'وخاصة الثقب الخرساني والقص والهدم في تونس.',
                    whoWeAreDescription3:
                        'نضع خبرتنا ومعداتنا الاحترافية المتطورة في خدمتكم لإنجاز تدخلات دقيقة ونظيفة ومناسبة لجميع أنواع المشاريع. وبفضل التقنيات الحديثة، نتدخل على مختلف المواد سواء الخرسانة أو جدران البناء أو غيرها من الهياكل، مع ضمان جودة عالية في التنفيذ.',
                    whoWeAreDescription4:
                        'نقوم أيضاً بأعمال الهدم الجزئي أو الكلي مع ضمان عمليات آمنة ومدروسة للحفاظ على المنشآت المجاورة وتقليل التأثير على موقع العمل.',
                    whoWeAreDescription5:
                        'بفضل خبرتنا والتزامنا بالجودة، نرافق الأفراد والمهنيين في إنجاز مشاريعهم منذ دراسة الاحتياجات وحتى التنفيذ النهائي للأعمال.',
                    comingSoon: 'قريباً',
                    contactUs: 'تواصل معنا',

                    messageGetInTouch:
                        'شكراً لتواصلكم معنا. لقد استلمنا رسالتكم وسيقوم فريقنا بمراجعتها في أقرب وقت. رضاكم هو أولويتنا وسنرد عليكم في أسرع الآجال.',

                    email: 'البريد الإلكتروني',
                    contact: 'تواصل',
                    joinMessageFailedTitle: 'عذراً! حدث خطأ ما',
                    messageDescription: 'فشل إرسال الرسالة. يرجى المحاولة مرة أخرى لاحقاً.',
                    messageTitle: 'شكراً على رسالتكم!',
                    dismiss: 'إغلاق'
                }
            }
        }
    });

export default i18n;